export const isEnum = <T>(value: unknown, enumToMatch: Record<string, T>): value is T => {
    return Object.values(enumToMatch).includes(value as T);
};
